import React from "react";
import i18n from "@microdoing/shared/i18n";
import { Box, MainText, PressableOpacity } from "app/components/common";
import CrossIcon from "app/components/Icons/CrossIcon";
import moment from "moment";
import { StyleSheet } from "react-native";
import HourBoxSelector from "./HourBoxSelector";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  removeIcon: {
    marginLeft: 15,
  },
  invisible: {
    zIndex: -1,
    opacity: 0,
  },
  visible: {
    zIndex: 1,
    opacity: 1,
  },
});

interface ReminderTimeProps {
  hour: number;
  minute: number;
}
interface Props {
  reminderNumber: number;
  isLastReminder?: boolean;
  reminderTime: {
    hour: number;
    minute: number;
  };
  onRemove: () => void;
  onChangeReminderTime: (data: ReminderTimeProps) => void;
}

const ReminderHour = ({
  reminderNumber,
  reminderTime = {
    hour: moment().hour(),
    minute: moment().minute(),
  },
  onRemove,
  onChangeReminderTime = () => null,
  isLastReminder = false,
}: Props) => {
  return (
    <Box flexDirection="row" marginBottom="m">
      <Box flex={1} flexDirection="column">
        <MainText variant="l3-medium" color="neutral.500">
          {i18n.t("reminder") + ` ${reminderNumber}`}
        </MainText>
        <MainText variant="l2-medium" color="neutral.500">
          {i18n.t("reminder-hour")}
        </MainText>
      </Box>
      <Box flexDirection="row" alignItems="center">
        <HourBoxSelector
          reminderTime={reminderTime}
          onChangeReminderTime={onChangeReminderTime}
        />
        <PressableOpacity
          style={[
            styles.removeIcon,
            isLastReminder ? styles.visible : styles.invisible,
          ]}
          onPress={
            isLastReminder && reminderNumber !== 1 ? onRemove : () => null
          }
        >
          <CrossIcon
            height={15}
            width={15}
            color={
              isLastReminder && reminderNumber !== 1
                ? theme.colors["neutral.900"]
                : theme.colors.transparent
            }
          />
        </PressableOpacity>
      </Box>
    </Box>
  );
};

export default ReminderHour;
